import { useEffect, useState } from 'react';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
const generatePages = (totalPages, currentPage) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push({
            page: i,
            isCurrent: i === currentPage,
        });
    }
    return pages;
};
const usePagination = ({ onPageChange, totalPages = 0, defaultCurrentPage, currentPage, }) => {
    const [page = currentPage || defaultCurrentPage || 1, setPage] = useControllableState({
        prop: currentPage,
        defaultProp: defaultCurrentPage,
        onChange: onPageChange,
    });
    const [pages, setPages] = useState(() => generatePages(totalPages, page));
    useEffect(() => {
        if (page > totalPages) {
            setPage(totalPages);
        }
    }, [page]);
    useEffect(() => {
        setPages(generatePages(totalPages, page));
    }, [totalPages, page]);
    const hasNext = page < totalPages;
    const hasPrev = page > 1;
    const prevPage = hasPrev ? page - 1 : page;
    const nextPage = hasNext ? page + 1 : page;
    return {
        currentPage: page,
        totalPages,
        pages,
        hasPrev,
        hasNext,
        setPage,
        prevPage,
        nextPage,
    };
};
export default usePagination;
